import { useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, BarChart3, Crown } from "lucide-react";
import Seo from "../components/Seo";
import { PageHero, Reveal } from "../components/common/Section";
import CourseGrid from "../components/learning/CourseGrid";
import { useAuth } from "../context/AuthContext";

const PATH = [
  { level: "Beginner", icon: Sprout, text: "Budgeting, emergency funds, debt and compounding." },
  { level: "Intermediate", icon: BarChart3, text: "Mutual funds, SIPs, costs and fund research." },
  { level: "Advanced", icon: Crown, text: "Allocation, diversification, rebalancing and tax efficiency." },
];

export default function Learn() {
  const [level, setLevel] = useState("All");
  const { user } = useAuth();
  return (
    <>
      <Seo title="Financial Education Courses" path="/learn" description="Free beginner-to-advanced financial education courses from Quantora: money foundations, mutual funds and SIPs, portfolio construction and risk." />
      <PageHero eyebrow="Quantora Learning" title="Learn money, from first budget to full portfolio." text="Structured, free courses with short lessons and key takeaways. Sign in to track your progress across devices.">
        {!user && <Link to="/register" data-testid="learn-register-btn" className="mt-8 inline-flex rounded-full bg-mint px-6 py-3.5 text-sm font-semibold text-navy">Create a free account to track progress</Link>}
      </PageHero>
      <section className="bg-white py-16">
        <div className="container-q grid gap-5 md:grid-cols-3" data-testid="learning-path">
          {PATH.map((p, i) => (
            <Reveal key={p.level} delay={i * 0.08}>
              <div className="relative h-full rounded-2xl border border-slate-200 p-6">
                <span className="font-num text-xs text-gold-600">STEP 0{i + 1}</span>
                <div className="mt-3 flex items-center gap-3"><p.icon size={20} className="text-mint-600" /><h3 className="text-lg font-bold text-navy">{p.level}</h3></div>
                <p className="mt-2 text-sm text-slate-600">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="bg-slate-100/70 py-20">
        <div className="container-q">
          <div className="mb-10 flex flex-wrap gap-2">
            {["All", "Beginner", "Intermediate", "Advanced"].map((l) => (
              <button key={l} onClick={() => setLevel(l)} data-testid={`learn-level-${l.toLowerCase()}`}
                className={`rounded-full px-5 py-2 text-sm font-medium transition-colors ${level === l ? "bg-navy text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
            ))}
          </div>
          <CourseGrid level={level} />
          <p className="mt-12 text-xs text-slate-500">All courses are for educational purposes only and do not constitute investment, insurance or tax advice.</p>
        </div>
      </section>
    </>
  );
}
